import { render } from "./enrolment-menu.vue?vue&type=template&id=2303bdfd&ts=true"
import script from "./enrolment-menu.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-menu.ts?vue&type=script&lang=ts&external"

import "./enrolment-menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__